import { useState } from 'react'
import { useI18n } from '../../../../i18n/i18n'
import './contato-painel.scss'

// NOTE: envio atual abre o cliente de e-mail do visitante (mailto), o que já
// funciona sem backend. Em produção, trocar por um POST para um endpoint
// próprio ou para o Netlify Forms (o deploy atual é Netlify).
export function ContatoPainel() {
  const { t } = useI18n()
  const email = t('footer.email') as string

  const [nome, setNome] = useState('')
  const [remetente, setRemetente] = useState('')
  const [assunto, setAssunto] = useState('')
  const [mensagem, setMensagem] = useState('')
  const [erros, setErros] = useState<{ nome?: string; email?: string; mensagem?: string }>({})
  const [enviado, setEnviado] = useState(false)

  function validar() {
    const e: typeof erros = {}
    if (!nome.trim()) e.nome = t('contato.erroNome')
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(remetente.trim())) e.email = t('contato.erroEmail')
    if (!mensagem.trim()) e.mensagem = t('contato.erroMensagem')
    setErros(e)
    return Object.keys(e).length === 0
  }

  function handleSubmit(ev: React.FormEvent) {
    ev.preventDefault()
    if (!validar()) return
    const subject = assunto.trim() || `Contato pelo site - ${nome.trim()}`
    const body = `${mensagem.trim()}\n\n---\n${nome.trim()}\n${remetente.trim()}`
    window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
    setEnviado(true)
  }

  return (
    <section className="contato-painel">
      <div className="contato-painel__intro">
        <span className="eyebrow">{t('contato.eyebrow')}</span>
        <h1 className="section-heading">{t('contato.title')}</h1>
        <p>{t('contato.sub')}</p>
        <p className="contato-painel__direto">
          {t('contato.direto')} <a href={`mailto:${email}`}>{email}</a>
        </p>
      </div>

      <form className="contato-painel__form" onSubmit={handleSubmit} noValidate>
        <label className="field">
          <span>{t('contato.nome')}</span>
          <input value={nome} onChange={(e) => setNome(e.target.value)} type="text" />
          {erros.nome && <em className="field__erro">{erros.nome}</em>}
        </label>

        <label className="field">
          <span>{t('contato.email')}</span>
          <input value={remetente} onChange={(e) => setRemetente(e.target.value)} type="email" />
          {erros.email && <em className="field__erro">{erros.email}</em>}
        </label>

        <label className="field">
          <span>{t('contato.assunto')}</span>
          <input value={assunto} onChange={(e) => setAssunto(e.target.value)} type="text" />
        </label>

        <label className="field">
          <span>{t('contato.mensagem')}</span>
          <textarea value={mensagem} onChange={(e) => setMensagem(e.target.value)} rows={5} />
          {erros.mensagem && <em className="field__erro">{erros.mensagem}</em>}
        </label>

        <button className="btn btn-primary" type="submit">{t('contato.enviar')}</button>

        {enviado && <p className="contato-painel__sucesso">{t('contato.sucesso')}</p>}
      </form>
    </section>
  )
}
